import * as api from '../api/mortgagelender';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';
import * as eventApi from '@modules/events/api/event';

export const MORTGAGELENDER_SEARCH_OPTIONS_FETCH_START =
  'APPRAISAL/MORTGAGELENDER_SEARCH_OPTIONS_FETCH_START';
export const MORTGAGELENDER_SEARCH_OPTIONS_FETCH_SUCCESS =
  'APPRAISAL/MORTGAGELENDER_SEARCH_OPTIONS_FETCH_SUCCESS';
export const MORTGAGELENDER_SEARCH_OPTIONS_FETCH_ERROR =
  'APPRAISAL/MORTGAGELENDER_SEARCH_OPTIONS_FETCH_ERROR';

export const MORTGAGELENDER_SEARCH_START =
  'APPRAISAL/MORTGAGELENDER_SEARCH_START';
export const MORTGAGELENDER_SEARCH_SUCCESS =
  'APPRAISAL/MORTGAGELENDER_SEARCH_SUCCESS';
export const MORTGAGELENDER_SEARCH_ERROR =
  'APPRAISAL/MORTGAGELENDER_SEARCH_ERROR';

export const MORTGAGELENDER_TAGS_FETCH_START =
  'APPRAISAL/MORTGAGELENDER_TAGS_FETCH_START';
export const MORTGAGELENDER_TAGS_FETCH_SUCCESS =
  'APPRAISAL/MORTGAGELENDER_TAGS_FETCH_SUCCESS';
export const MORTGAGELENDER_TAGS_FETCH_ERROR =
  'APPRAISAL/MORTGAGELENDER_TAGS_FETCH_ERROR';

export const MORTGAGELENDER_FIELDS_FETCH_START =
  'APPRAISAL/MORTGAGELENDER_FIELDS_FETCH_START';
export const MORTGAGELENDER_FIELDS_FETCH_SUCCESS =
  'APPRAISAL/MORTGAGELENDER_FIELDS_FETCH_SUCCESS';
export const MORTGAGELENDER_FIELDS_FETCH_ERROR =
  'APPRAISAL/MORTGAGELENDER_FIELDS_FETCH_ERROR';

export const MORTGAGELENDER_CHANGE_CURRENT_PAGE =
  'APPRAISAL/MORTGAGELENDER_CHANGE_CURRENT_PAGE';
export const MORTGAGELENDER_CHANGE_SORT_MODEL =
  'APPRAISAL/MORTGAGELENDER_CHANGE_SORT_MODEL';
export const MORTGAGELENDER_CHANGE_PAGE_SIZE =
  'APPRAISAL/MORTGAGELENDER_CHANGE_PAGE_SIZE';

export const MORTGAGELENDER_RESET_DATA = 'APPRAISAL/MORTGAGELENDER_RESET_DATA';
export const MORTGAGELENDER_FETCH_START =
  'APPRAISAL/MORTGAGELENDER_FETCH_START';
export const MORTGAGELENDER_FETCH_SUCCESS =
  'APPRAISAL/MORTGAGELENDER_FETCH_SUCCESS';
export const MORTGAGELENDER_FETCH_ERROR =
  'APPRAISAL/MORTGAGELENDER_FETCH_ERROR';

export const MORTGAGELENDER_UPDATE_START =
  'APPRAISAL/MORTGAGELENDER_UPDATE_START';
export const MORTGAGELENDER_UPDATE_SUCCESS =
  'APPRAISAL/MORTGAGELENDER_UPDATE_SUCCESS';
export const MORTGAGELENDER_UPDATE_ERROR =
  'APPRAISAL/MORTGAGELENDER_UPDATE_ERROR';

export const MORTGAGELENDER_NOTES_FETCH_START =
  'APPRAISAL/MORTGAGELENDER_NOTES_FETCH_START';
export const MORTGAGELENDER_NOTES_FETCH_SUCCESS =
  'APPRAISAL/MORTGAGELENDER_NOTES_FETCH_SUCCESS';
export const MORTGAGELENDER_NOTES_FETCH_ERROR =
  'APPRAISAL/MORTGAGELENDER_NOTES_FETCH_ERROR';

export const MORTGAGELENDER_PROPERTIES_FETCH_START =
  'APPRAISAL/MORTGAGELENDER_PROPERTIES_FETCH_START';
export const MORTGAGELENDER_PROPERTIES_FETCH_SUCCESS =
  'APPRAISAL/MORTGAGELENDER_PROPERTIES_FETCH_SUCCESS';
export const MORTGAGELENDER_PROPERTIES_FETCH_ERROR =
  'APPRAISAL/MORTGAGELENDER_PROPERTIES_FETCH_ERROR';

export const MORTGAGELENDER_NOTE_ADD_START =
  'APPRAISAL/MORTGAGELENDER_NOTE_ADD_START';
export const MORTGAGELENDER_NOTE_ADD_SUCCESS =
  'APPRAISAL/MORTGAGELENDER_NOTE_ADD_SUCCESS';
export const MORTGAGELENDER_NOTE_ADD_ERROR =
  'APPRAISAL/MORTGAGELENDER_NOTE_ADD_ERROR';

export const MORTGAGELENDER_NOTE_UPDATE_START =
  'APPRAISAL/MORTGAGELENDER_NOTE_UPDATE_START';
export const MORTGAGELENDER_NOTE_UPDATE_SUCCESS =
  'APPRAISAL/MORTGAGELENDER_NOTE_UPDATE_SUCCESS';
export const MORTGAGELENDER_NOTE_UPDATE_ERROR =
  'APPRAISAL/MORTGAGELENDER_NOTE_UPDATE_ERROR';

export const MORTGAGELENDER_NOTE_DELETE_START =
  'APPRAISAL/MORTGAGELENDER_NOTE_DELETE_START';
export const MORTGAGELENDER_NOTE_DELETE_SUCCESS =
  'APPRAISAL/MORTGAGELENDER_NOTE_DELETE_SUCCESS';
export const MORTGAGELENDER_NOTE_DELETE_ERROR =
  'APPRAISAL/MORTGAGELENDER_NOTE_DELETE_ERROR';

export const MORTGAGELENDER_VALIDATE_START =
  'APPRAISAL/MORTGAGELENDER_VALIDATE_START';
export const MORTGAGELENDER_VALIDATE_SUCCESS =
  'APPRAISAL/MORTGAGELENDER_VALIDATE_SUCCESS';
export const MORTGAGELENDER_VALIDATE_ERROR =
  'APPRAISAL/MORTGAGELENDER_VALIDATE_ERROR';

export const MORTGAGELENDER_CREATE = createRequestTypes(
  'APPRAISAL/MORTGAGELENDER_CREATE',
);

export const FETCH_PROPERTY_MORTGAGE_LENDERS_START =
  'APPRAISAL/FETCH_PROPERTY_MORTGAGE_LENDERS_START';
export const FETCH_PROPERTY_MORTGAGE_LENDERS_SUCCESS =
  'APPRAISAL/FETCH_PROPERTY_MORTGAGE_LENDERS_SUCCESS';
export const FETCH_PROPERTY_MORTGAGE_LENDERS_ERROR =
  'APPRAISAL/FETCH_PROPERTY_MORTGAGE_LENDERS_ERROR';

export const fetchSearchOptions = makeApiActionCreatorV3(
  api.fetchSearchOptions,
  MORTGAGELENDER_SEARCH_OPTIONS_FETCH_START,
  MORTGAGELENDER_SEARCH_OPTIONS_FETCH_SUCCESS,
  MORTGAGELENDER_SEARCH_OPTIONS_FETCH_ERROR,
);
export const searchMortgagelender = makeApiActionCreatorV3(
  api.searchMortgagelender,
  MORTGAGELENDER_SEARCH_START,
  MORTGAGELENDER_SEARCH_SUCCESS,
  MORTGAGELENDER_SEARCH_ERROR,
);
export const fetchFields = makeApiActionCreatorV3(
  api.fetchFields,
  MORTGAGELENDER_FIELDS_FETCH_START,
  MORTGAGELENDER_FIELDS_FETCH_SUCCESS,
  MORTGAGELENDER_FIELDS_FETCH_ERROR,
);
export const fetchTags = makeApiActionCreatorV3(
  api.fetchTags,
  MORTGAGELENDER_TAGS_FETCH_START,
  MORTGAGELENDER_TAGS_FETCH_SUCCESS,
  MORTGAGELENDER_TAGS_FETCH_ERROR,
);
export const fetchMortgagelender = makeApiActionCreatorV3(
  api.fetchMortgagelender,
  MORTGAGELENDER_FETCH_START,
  MORTGAGELENDER_FETCH_SUCCESS,
  MORTGAGELENDER_FETCH_ERROR,
);
export const updateMortgagelender = makeApiActionCreatorV3(
  api.updateMortgagelender,
  MORTGAGELENDER_UPDATE_START,
  MORTGAGELENDER_UPDATE_SUCCESS,
  MORTGAGELENDER_UPDATE_ERROR,
);
export const createMortgagelender = makeApiActionCreatorV3(
  api.createMortgagelender,
  MORTGAGELENDER_CREATE[START],
  MORTGAGELENDER_CREATE[SUCCESS],
  MORTGAGELENDER_CREATE[ERROR],
);
export const fetchMortgagelenderNotes = makeApiActionCreatorV3(
  api.fetchMortgagelenderNotes,
  MORTGAGELENDER_NOTES_FETCH_START,
  MORTGAGELENDER_NOTES_FETCH_SUCCESS,
  MORTGAGELENDER_NOTES_FETCH_ERROR,
);
export const fetchMortgagelenderProperties = makeApiActionCreatorV3(
  api.fetchMortgagelenderProperties,
  MORTGAGELENDER_PROPERTIES_FETCH_START,
  MORTGAGELENDER_PROPERTIES_FETCH_SUCCESS,
  MORTGAGELENDER_PROPERTIES_FETCH_ERROR,
);
export const updateMortgagelenderNote = makeApiActionCreatorV3(
  api.updateMortgagelenderNote,
  MORTGAGELENDER_NOTE_UPDATE_START,
  MORTGAGELENDER_NOTE_UPDATE_SUCCESS,
  MORTGAGELENDER_NOTE_UPDATE_ERROR,
);
export const addMortgagelenderNote = makeApiActionCreatorV3(
  api.addMortgagelenderNote,
  MORTGAGELENDER_NOTE_ADD_START,
  MORTGAGELENDER_NOTE_ADD_SUCCESS,
  MORTGAGELENDER_NOTE_ADD_ERROR,
);
export const deleteMortgagelenderNote = makeApiActionCreatorV3(
  api.deleteMortgagelenderNote,
  MORTGAGELENDER_NOTE_DELETE_START,
  MORTGAGELENDER_NOTE_DELETE_SUCCESS,
  MORTGAGELENDER_NOTE_DELETE_ERROR,
);
export const validateMortgagelender = makeApiActionCreatorV3(
  api.validateMortgagelender,
  MORTGAGELENDER_VALIDATE_START,
  MORTGAGELENDER_VALIDATE_SUCCESS,
  MORTGAGELENDER_VALIDATE_ERROR,
);

export function changeCurrentPage(page) {
  return async dispatch => {
    dispatch({ type: MORTGAGELENDER_CHANGE_CURRENT_PAGE, data: page });
  };
}

export function changeSortModel(model) {
  return async dispatch => {
    dispatch({ type: MORTGAGELENDER_CHANGE_SORT_MODEL, data: model });
  };
}

export function changePageSize(page) {
  return async dispatch => {
    dispatch({ type: MORTGAGELENDER_CHANGE_PAGE_SIZE, data: page });
  };
}

export function resetMortgagelenderData() {
  return async dispatch => {
    dispatch({ type: MORTGAGELENDER_RESET_DATA });
  };
}

// lender events
export const LENDER_EVENTS_FETCH = createRequestTypes(
  'APPRAISAL/LENDER/LENDER_EVENTS_FETCH',
);

export const fetchLenderEvents = makeApiActionCreatorV3(
  api.fetchLenderEvents,
  LENDER_EVENTS_FETCH[START],
  LENDER_EVENTS_FETCH[SUCCESS],
  LENDER_EVENTS_FETCH[ERROR],
);

export const LENDER_EVENT_DELETE = createRequestTypes(
  'APPRAISAL/LENDER/LENDER_EVENT_DELETE',
);
export const deleteLenderEvent = makeApiActionCreatorV3(
  eventApi.deleteEvent,
  LENDER_EVENT_DELETE[START],
  LENDER_EVENT_DELETE[SUCCESS],
  LENDER_EVENT_DELETE[ERROR],
);

export const PROPERTY_MORTGAGE_LENDERS_FETCH = createRequestTypes(
  'APPRAISAL/LENDERS/PROPERTY_MORTGAGE_LENDERS_FETCH',
);

export const fetchPropertyMortgageLenders = makeApiActionCreatorV3(
  api.fetchPropertyMortgageLenders,
  PROPERTY_MORTGAGE_LENDERS_FETCH[START],
  PROPERTY_MORTGAGE_LENDERS_FETCH[SUCCESS],
  PROPERTY_MORTGAGE_LENDERS_FETCH[ERROR],
);

export const GET_PROPERTY_MORTGAGE_LENDER = createRequestTypes(
  'APPRAISAL/LENDERS/GET_PROPERTY_MORTGAGE_LENDER',
);

export const getPropertyMortgageLender = makeApiActionCreatorV3(
  api.getPropertyMortgageLender,
  GET_PROPERTY_MORTGAGE_LENDER[START],
  GET_PROPERTY_MORTGAGE_LENDER[SUCCESS],
  GET_PROPERTY_MORTGAGE_LENDER[ERROR],
);

export const DELETE_PROPERTY_MORTGAGE_LENDER = createRequestTypes(
  'APPRAISAL/LENDERS/DELETE_PROPERTY_MORTGAGE_LENDER',
);

export const deletePropertyMortgagelender = makeApiActionCreatorV3(
  api.deletePropertyMortgagelender,
  DELETE_PROPERTY_MORTGAGE_LENDER[START],
  DELETE_PROPERTY_MORTGAGE_LENDER[SUCCESS],
  DELETE_PROPERTY_MORTGAGE_LENDER[ERROR],
);

export const INSERT_PROPERTY_MORTGAGE_LENDER = createRequestTypes(
  'APPRAISAL/LENDERS/INSERT_PROPERTY_MORTGAGE_LENDER',
);

export const insertProperyMortgageLender = makeApiActionCreatorV3(
  api.insertProperyMortgageLender,
  INSERT_PROPERTY_MORTGAGE_LENDER[START],
  INSERT_PROPERTY_MORTGAGE_LENDER[SUCCESS],
  INSERT_PROPERTY_MORTGAGE_LENDER[ERROR],
);
